import React from 'react';
import MulSelector, { renderImgText } from './MultipleSelector';
import Twitch from '@/pages/intelligence/assets/svg/dataSource/twitch.svg';
import Fbgaming from '@/pages/intelligence/assets/svg/dataSource/fbgaming.svg';
import Youtube from '@/pages/intelligence/assets/svg/dataSource/youtube.svg';
import { useIntl } from 'umi';

export default function KolPlatform(props: any) {
  const { onConfirm, value = ['twitch', 'ytg', 'facebook',], onFetchSuccess } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  const options = [
    { value: 'twitch', text: 'Twitch', img: Twitch },
    { value: 'ytg', text: 'YouTube', img: Youtube },
    { value: 'facebook', text: 'Facebook Gaming', img: Fbgaming },
  ];


  const optionsRender = options?.map((item,) => ({
    value: item?.value,
    text: renderImgText(item?.text, item?.img),
  }));

  const handleChange = (value: string[]) => {
    if (onConfirm instanceof Function) {
      onConfirm(value);
      onFetchSuccess(value)
    }
  };

  return (
    <MulSelector
      value={value}
      options={optionsRender}
      buttonName={formatMessage({ id: 'dbi_platform' })}
      onChange={handleChange}
    />
  );
}
